import { render, staticRenderFns } from "./TabNav.vue?vue&type=template&id=30d380bb&scoped=true&"
import script from "./TabNav.vue?vue&type=script&lang=ts&"
export * from "./TabNav.vue?vue&type=script&lang=ts&"
import style0 from "./TabNav.vue?vue&type=style&index=0&id=30d380bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d380bb",
  null
  
)

export default component.exports